import styled from '@emotion/styled';

export default styled.div`
    &.public-cms-section-wrapper--hidden {
        display: none;
    }
`;
